<template>
    <Modal
        v-model="visible"
        :mask-closable="false"
        title="配置机构业绩目标"
        :footer-hide="true"
        width="800"
        class="my-modal top p-b modal-box"
    >
        <span class="title-desc" v-if="showTable">机构业绩包含其直属团队、下级机构的业绩</span>
        <div class="config-container">
            <div class="fee-status">
                <Form ref="form" :model="form" :label-width="100" class="modal-form less" :rules="ruleInline">
                    <FormItem
                        prop="month"
                        key="month"
                        label="请选择月份"
                        :rules="$units.formRule.required('请选择月份', (trigger = 'change'), (type = 'date'))"
                    >
                        <DatePicker
                            format="yyyy-MM"
                            type="month"
                            :clearable="false"
                            split-panels
                            v-model="form.month"
                            placeholder="请选择"
                            style="width: 240px"
                            @on-change="queryList"
                            transfer
                        ></DatePicker>
                    </FormItem>

                    <FormItem class="fyb-target" prop="fybTarget" key="fybTarget" label="本公司标保目标" :label-width="130">
                        <Input
                            style="width: 210px"
                            type="number"
                            :disabled="form.createBy == organId ? false : true && isFybTargetVal"
                            v-model="form.fybTarget"
                            placeholder="请输入"
                        />
                        <span class="money">元</span>
                    </FormItem>

                    <Table :columns="columns" :data="form.targetList" class="table-box" v-if="showTable">
                        <template slot-scope="{ row, index }" slot="fybTarget">
                            <FormItem
                                :key="'targetList.' + index + '.fybTarget'"
                                class="form-item"
                                :prop="'targetList.' + index + '.fybTarget'"
                            >
                                <InputNumber
                                    v-if="index"
                                    :disabled="!row.createBy || organId == row.createBy || row.fybTarget==0? false : true"
                                    :min="0"
                                    :precision="0"
                                    class="table-input"
                                    v-model="row.fybTarget"
                                    placeholder="请填写"
                                    @on-change="changeTableMoney(row, index)"
                                ></InputNumber>
                                <span v-else class="table-first-row">{{ row.fybTarget }}</span>
                            </FormItem>
                        </template>
                    </Table>
                </Form>
            </div>
        </div>
        <div style="height: 30px"></div>
        <div class="action-buttom">
            <div class="buttom-box">
                <Button class="cancel" @click="visible = false">取消</Button>
                <Button type="primary" @click="ok" :loading="loading">
                    <span v-if="!loading">确认</span>
                </Button>
            </div>
        </div>
    </Modal>
</template>

<script>
import filters from '@/api/filter';
export default {
    props: ['initData'],
    data() {
        return {
            visible: false,
            loading:false,
            columns: [
                {
                    title: '下级机构简称',
                    key: 'organizationName',
                    align: 'center'
                },
                {
                    title: '机构类型',
                    align: 'center',
                    key: 'orgType',
                    render(h, params) {
                        let orgType = params.row.orgType;
                        if (orgType == 1) {
                            return <span>总部</span>;
                        } else if (orgType == 2) {
                            return <span>省分</span>;
                        } else if (orgType == 3) {
                            return <span>市级</span>;
                        } else if (orgType == 4) {
                            return <span>区级</span>;
                        } else if (orgType == 5) {
                            return <span>渠道</span>;
                        }
                    }
                },
                {
                    title: '设置标保目标(元)',
                    align: 'center',
                    slot: 'fybTarget'
                }
            ],
            form: {
                delFlag: '',
                month: '',
                organizationId: '',
                targetList: [],
                tenantId: '',
                fybTarget: ''
            },
            ruleInline: {
                serverEndDate: [
                    {
                        required: true,
                        type: 'date',
                        message: '请选择时间',
                        trigger: 'change'
                    }
                ]
            },
            organId: JSON.parse(localStorage.userInfo).organId,
            isFybTargetVal: null,
            showTable:true
        };
    },

    methods: {
        open() {
            this.visible = true;
            let date = new Date();
            let year = date.getFullYear();
            let month = date.getMonth() + 1;
            month = month > 9 ? month : '0' + month;
            this.form.month = year + '-' + month;
            this.queryList();
        },

        // 获取列表
        queryList() {
            this.$http({
                url: '/buz/dataCenter/queryTarget',
                type: 'GET',
                data: {
                    month: filters.filterTime(this.form.month, 'YYYY-MM')
                }
            }).then(res => {
                this.isFybTargetVal = res.data.fybTarget && Number(res.data.fybTarget) > 0 ? true : false;
                this.form = res.data;
                this.$set(this.form, 'month', new Date(res.data.month));

                this.form.targetList = res.data.targetList.map(item => {
                    return {
                        ...item,
                        fybTarget: item.fybTarget ? item.fybTarget : 0,
                        disabled: item.organId == this.organId ? false : true
                    };
                });
                if(res.data.targetList.length){
                    this.form.targetList.unshift({
                        organizationName: '合计',
                        disabled: true,
                        fybTarget: this.form.targetList.reduce((a, b) => a + b.fybTarget, 0)
                    });
                }else{
                    this.showTable = false;
                }
            });
        },

        // 设置标保目标
        changeTableMoney(row, index) {
            // 设置对应数据字段值
            this.form.targetList[index].fybTarget = row.fybTarget;
            //过滤第一条合计
            let targetList = JSON.parse(JSON.stringify(this.form.targetList));
            let arr = targetList.filter((item, index) => index);
            // 求和
            let num = arr.reduce((a, b) => a + Number(b.fybTarget), 0);
            this.form.targetList[0].fybTarget = num;
        },

        ok() {
            this.$refs.form.validate().then(isok => {
                if (!isok) {
                    return;
                }
                this.submit();
            });
        },

        submit() {
            let data = JSON.parse(JSON.stringify(this.form));
            data.month = filters.filterTime(data.month, 'YYYY-MM');
            data.targetList.forEach(item => {
                item.fybTarget = Number(item.fybTarget);
            });
            data.targetList.splice(0, 1); //删除第一条合计
            this.loading = true;
            this.$http({
                url: `/buz/dataCenter/saveTarget`,
                type: 'POST',
                data,
                apiPermissionCode:'dataCenter_1_2_1'
            }).then(res => {
                this.initData();
                this.$notice.success('保存成功');
            }).finally(()=>{
                this.visible = false;
                this.loading = false;
            });
        }
    }
};
</script>

<style lang="scss" scoped>
.modal-box {
    position: relative;
    .title-desc {
        position: absolute;
        top: 11px;
        left: 145px;
        color: #727c8e;
        font-size: 12px;
    }
    .action-buttom {
        width: 93%;
        display: flex;
        justify-content: center;
        position: absolute;
        background: #fff;
        bottom: 0;
        z-index: 1;
        padding: 15px 0;
        .buttom-box {
            width: 50%;
            display: flex;
            justify-content: center;
            justify-content: space-between;
            Button {
                width: 140px;
                height: 36px;
            }
            .cancel {
                width: 120px;
                border-color: #236dff;
                color: #236dff;
            }
        }
    }
}
.config-container {
    .fee-status {
        .form-item {
            display: flex;
            align-items: center;
            /deep/ .ivu-form-item-content {
                margin-left: 15px !important;
            }
        }
        .table-box {
            /deep/ .ivu-form-item {
                margin-bottom: 0 !important;
            }
            /deep/.ivu-input-number-input[disabled] {
                color: #000;
            }
        }
        .table-input {
            width: 195px !important;
        }
        .table-first-row {
            display: block;
            width: 195px !important;
            color: #515C6F;
        }
        /deep/ .ivu-input-number-input {
            text-align: center !important;
        }
        .fyb-target {
            width: 50%;
            position: relative;
            .money {
                position: absolute;
                right: 55px;
            }
        }
    }
}
</style>
